export const messages = {
  title: { id: 'admin/promotions.form.conditions.order-value' },
  subtitle: { id: 'admin/promotions.form.conditions.order-value.subtitle' },
  min: { id: 'admin/promotions.form.conditions.order-value.min' },
  max: { id: 'admin/promotions.form.conditions.order-value.max' },
  select: { id: 'admin/promotions.form.conditions.order-value.select' },
  allItems: { id: 'admin/promotions.form.conditions.order-value.all-items' },
  includeMatchedItems: {
    id: 'admin/promotions.form.conditions.order-value.only-promotion-items',
  },
  excludeMatchedItems: {
    id: 'admin/promotions.form.conditions.order-value.except-promotion-items',
  },
  validation: {
    select: { id: 'admin/promotions.form.validation.select-an-option' },
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    maxLowerThanMin: {
      id: 'admin/promotions.form.validation.max-greater-than-min',
    },
    minGreaterThanMax: {
      id: 'admin/promotions.form.validation.min-lower-than-max',
    },
  },
  view: {
    title: { id: 'admin/promotions.form.conditions.order-value.view.title' },
    intervalValue: {
      id: 'admin/promotions.form.conditions.order-value.view.interval-value',
    },
  },
}
